<script setup></script>

<template>
  <PageLayout>
    <template #headerTitle>Transactions</template>
    <VBusHelper
      :emitOnMounted="$constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH"
    />
    <div class="py-4"></div>
    <TransactionsLoadingError
      @refresh="
        () => $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH)
      "
      v-if="$stores.transactions?.state?.list_all?.error"
    >
      <template #errorDescription>
        {{ $stores.transactions?.state?.list_all?.error }}
      </template>
    </TransactionsLoadingError>
    <div
      v-else-if="$stores.transactions?.state?.list_all?.list.length"
      class="space-y-4 divide-y divide-[#DCD2F8] px-6"
    >
      <TransactionItem
        @click="$bus.emit($constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, trx)"
        v-for="trx in $stores.transactions?.state?.list_all?.list"
        :item="trx"
      />
    </div>
    <div
      v-else-if="$stores.transactions?.state?.list_all?.loading"
      class="space-y-4 divide-y divide-transparent px-6 shimmerContainer"
    >
      <TransactionItem v-for="trx in 9" :item="trx" />
    </div>
    <EmptyTransactions
      @refresh="
        () => $bus.emit($constants.EVENTS.TRANSACTIONS.LIST_ALL.REFRESH)
      "
      v-else
    />
  </PageLayout>
</template>
